import { render } from "./Skills.vue?vue&type=template&id=00096ae7&scoped=true"
import script from "./Skills.vue?vue&type=script&lang=js"
export * from "./Skills.vue?vue&type=script&lang=js"

import "./Skills.vue?vue&type=style&index=0&id=00096ae7&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00096ae7"]])

export default __exports__